import React, { useEffect, useState } from "react";

const LocationDetails = ({ isOpen, onClose, data }) => {
  const [locationData, setLocationData] = useState({})

  useEffect(() => {
    try {
      const locationParsedData = JSON.parse(data.locationDetails);
      setLocationData(locationParsedData)
    } catch (error) {
      console.error("Error parsing locationDetails:", error);
    }

  }, [data])

  return (
    <div className={`modal fade ${isOpen ? "show d-block" : ""}`} tabIndex={-1} role="dialog">
      <div className="modal-dialog modal-xl modal-dialog-top" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h6 className="modal-title">Location Details</h6>
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body bg-secondary">
            <div className="row">
              <div className="col-lg-12">
                <table className="table table-bordered align-items-center table-flush">
                  <tbody>
                    <tr>
                      <td>IP Address</td>
                      <td>{locationData.org || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>IP Address</td>
                      <td>{locationData.ip || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>City</td>
                      <td>{locationData.city || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Region</td>
                      <td>{locationData.region || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Postal Code</td>
                      <td>{locationData.postal || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Coordinates</td>
                      <td>{locationData.loc || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Timezone</td>
                      <td>{locationData.timezone || "N/A"}</td>
                    </tr>
                    <tr>
                      <td>Country</td>
                      <td>{locationData.country || "N/A"}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-sm btn-outline-default" onClick={onClose}>
              <i className="fa fa-times" aria-hidden="true"></i> Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationDetails;
